import * as actionTypes from "../actions/actionTypes";

const initialState = {
  // token: null,
  // userId: null,
  // isAuth: false,
  locations: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOCATIONS:
      console.log("set locations reducer", action);
      const { payload } = action;
      return {
        ...state,
        locations: payload,
      };
    default:
      return state;
  }
};

export default reducer;
